import React from 'react';
import { NavLink, Redirect, Route, Switch } from 'react-router-dom';
import GeneralParameters from './GeneralParameters';
import PriceLimits from './PriceLimits';

const SystemParameters = ({ t, match }) => {
  return (
    <>
      <h5 className='km__u--text-has-emphasis'>
        {t('pages.default.systemParameters.title')}
      </h5>

      <ul className='km__p--gddk-tab-list'>
        <li>
          <NavLink
            className='km__u--text_title'
            to={`${match.url}/general-paramters`}
            activeClassName='km__p--gddk-tab-active'
          >
            {t('pages.default.systemParameters.generalParametersTitle')}
          </NavLink>
        </li>
        <li>
          <NavLink
            className='km__u--text_title'
            to={`${match.url}/price-limits`}
            activeClassName='km__p--gddk-tab-active'
          >
            {t('pages.default.systemParameters.priceLimitsTitle')}
          </NavLink>
        </li>
      </ul>

      <Switch>
        <Route
          path={`${match.url}/general-paramters`}
          render={(props) => <GeneralParameters t={t} {...props} />}
        />
        <Route
          path={`${match.url}/price-limits`}
          render={(props) => <PriceLimits t={t} {...props} />}
        />
        <Redirect to={`${match.url}/general-paramters`} />
      </Switch>
    </>
  );
};

export default SystemParameters;
